var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendProposal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "248px",
    height: "248px",
    viewBox: "0 0 248 248",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3613BC06-2853-47C5-BB5A-20DDEF003EF6@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Start-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01X---Onboarding",
    transform: "translate(-62.000000, -1068.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(19.000000, 1068.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-4",
    transform: "translate(43.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0,
    fill: "#FFFFFF",
    cx: 124,
    cy: 124,
    r: 124
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFF3DB",
    cx: 124,
    cy: 124,
    r: 68
  }), /*#__PURE__*/React.createElement("g", {
    id: "send-proposal",
    transform: "translate(52.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 60.220588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5222997,9.66176471 L21.4705882,51.5861384 C40.2861962,53.6953795 49.6940002,54.75 49.6940002,54.75 C49.6940002,54.75 63.5460001,52.1110306 91.25,46.8330919 C88.977494,40.7380372 87.841241,37.6905098 87.841241,37.6905098 C87.841241,37.6905098 68.4015939,28.3475948 29.5222997,9.66176471 Z",
    id: "Path-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,55.8235294 L20.0392157,55.8235294 C20.0392157,55.8235294 28.641049,21.5377326 30.0588235,5.07486631 C25.0590392,0.279117647 0,0 0,0 L0,55.8235294 L0,55.8235294 Z",
    id: "Stroke-19",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#FFD67E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.328031,41.8688284 L126.742197,36.95665 C134.869647,34.9966908 143.332564,39.545368 147.073529,46.7810069 L111.493697,61.5175422 C84.793575,72.0983745 83.5533637,71.0766414 70.8310324,66.4297206 L22.5441176,51.6931853",
    id: "Stroke-21",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1385717,34.8897059 L90.7163866,33.8059651 C99.2440441,35.9312013 100.838235,40.1867216 100.838235,48.9501656 L93.2468487,51.474199 C90.4987668,52.1607361 88.4339097,52.0294863 85.6554622,51.474199 C85.6554622,51.474199 59.6618578,45.8475831 54.1385717,42.9411765 C48.6152856,40.0347698 54.1385717,34.8897059 54.1385717,34.8897059 Z",
    id: "Stroke-23",
    fill: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9852941,9.66176471 L90.7163866,24.8059651 C99.2440441,26.9312013 100.838235,31.1867216 100.838235,39.9501656 L93.2468487,42.474199 C90.4987668,43.1607361 88.4339097,43.0294863 85.6554622,42.474199 L55.289916,34.9020988",
    id: "Stroke-23",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(34.000000, 0.000000)",
    stroke: "#17243D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2776305,51.712832 C69.0909322,61.4771921 55.4793144,61.0329802 47.1742729,52.7424074 C38.8692314,44.4518345 38.6820873,31.0299908 48.2014863,21.689085 C56.5772267,13.4690879 73.2871199,5 95,5 C83.9709715,16.0056628 86.3165115,43.1648653 78.2776305,51.712832 L78.2776305,51.712832 Z",
    id: "Stroke-13",
    fill: "#25D086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54065697,22.8832447 C12.5369644,27.0389184 19.0094623,27.0389184 23.0057697,22.8832447 C26.9980768,18.7275709 26.9980768,11.9969601 23.0057697,7.84128635 C19.0094623,3.68977241 10.4408031,0 0,0 C5.30440803,5.51593936 4.54834987,18.7275709 8.54065697,22.8832447 L8.54065697,22.8832447 Z",
    id: "Stroke-15",
    fill: "#25D086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,23 C31.0262246,30.9919994 40.7529558,75 40.7529558,75 C40.7529558,75 48.7833585,46.2021762 70,25.0760061",
    id: "Stroke-17"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F1F2F4",
    cx: 124,
    cy: 222,
    rx: 50,
    ry: 10
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendProposal);
export default __webpack_public_path__ + "static/media/send-proposal.c9042162bc4e146c49aa71f856f49e09.svg";
export { ForwardRef as ReactComponent };